import { useQuery } from "react-query";
import { getJSON } from "../api/http";
import { endpoints } from "../api/endpoints";

export interface ITr069Device {
    id: string;
    /* serialnumber: string;
    mac: string;
    description: string;
    creationdate: string;
    blocked: string;
    status: string;
    rxpower: string;
    deactivereason: string; */
}

export interface ITr069Data {
    list: ITr069Device[];
    total: number;
}

export const restructureTr069Data = (gponData: ITr069Data) =>
    gponData
        ? gponData.list.map(
            ({ /* serialnumber, blocked, rxpower, deactivereason, creationdate, mac, description, status, */ id }) => ({
                /* serialNumber: serialnumber,
                isBlocked: blocked,
                receiverPower: rxpower,
                deactivateReason: deactivereason,
                creationDate: creationdate,
                macAddress: mac,
                description,
                status, */
                id,
            })
        )
        : [];

const getTr069List = async () => getJSON(endpoints.devices.tr069.list);

export const useTr069List = () => {
    const { data, isLoading, error } = useQuery(
        "tr069List",
        getTr069List,
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        data: restructureTr069Data(data?.data),
        error,
    };
};
